export const actionsCartEnum = {
    INCREMENT: 1,
    DECREMENT: 2,
}